export default {
  IMAGE_TYPE_GIF: 'image/gif',
  IMAGE_TYPE_SVG: 'image/svg+xml',
  IMAGE_ACCEPT_TYPE: '.jpg, .png, .gif, .jpeg, .svg',
};
